<template>
  <div class="nobind">
    <div
      class="title"
      v-if="
        !(
          ($store.state.client == 'mac' || $store.state.client == 'windows') &&
          $store.state.version > '2.3.2'
        )
      "
    >
      输入绑定码
    </div>
    <div class="code-wrap">
      <div class="tips">{{ inputTips }}</div>
      <input
        v-model="activecode"
        v-on:input="inputFun()"
        @focus="onInputFocus"
        @blur="onInputBlur"
        @keydown.enter="bindDeviceClick"
      />
    </div>
    <div class="btn" @click="bindDeviceClick">立即绑定</div>

    <div class="getcode" @click="showDownloadClick">
      <div class="getcode-icon"></div>
      如何获取绑定码？
    </div>

    <div
      class="server-btn"
      @click="goServerPage"
      v-if="
        ($store.state.client == 'mac' || $store.state.client == 'windows') &&
        $store.state.version > '2.3.2'
      "
    >
      <span class="btn-title">切换设备端</span
      ><span class="btn-tips">（获取绑定码）</span>
    </div>
    <div class="know-us" v-if="show && !$store.getters.isAppstoreMode">
      <div class="know-text">小宝可以为我做什么？</div>
      <div class="know-btn" @click="knowClick">
        了解详情
        <div class="know-icon"></div>
      </div>
      <div class="close" @click="closeClick"></div>
    </div>
    <Download v-if="$store.state.isShowDownload == 1"></Download>
    <ChooseFirm v-if="$store.state.isShowDownload == 2"></ChooseFirm>
    <DownloadQh v-if="$store.state.isShowDownload == 3"></DownloadQh>
    <DownloadWlt v-if="$store.state.isShowDownload == 4"></DownloadWlt>
    <DownloadTwm v-if="$store.state.isShowDownload == 5"></DownloadTwm>
    <DownloadLx v-if="$store.state.isShowDownload == 6"></DownloadLx>
    <DownloadHk v-if="$store.state.isShowDownload == 7"></DownloadHk>
    <DownloadWin v-if="$store.state.isShowDownload == 8"></DownloadWin>
    <DownloadMac v-if="$store.state.isShowDownload == 9"></DownloadMac>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Download from "@/components/remote/Download.vue";
import ChooseFirm from "@/components/remote/ChooseFirm.vue";
import DownloadQh from "@/components/remote/DownloadQh.vue";
import DownloadWlt from "@/components/remote/DownloadWlt.vue";
import DownloadTwm from "@/components/remote/DownloadTwm.vue";
import DownloadLx from "@/components/remote/DownloadLx.vue";
import DownloadHk from "@/components/remote/DownloadHk.vue";
import DownloadWin from "@/components/remote/DownloadWin.vue";
import DownloadMac from "@/components/remote/DownloadMac.vue";

export default {
  data: function () {
    return {
      activecode: "",
      inputTips: "输入绑定码",

      show: true,
    };
  },
  components: {
    Download,
    ChooseFirm,
    DownloadQh,
    DownloadWlt,
    DownloadTwm,
    DownloadLx,
    DownloadHk,
    DownloadWin,
    DownloadMac,
  },
  methods: {
    ...mapActions(["sendUserlog"]),
    goServerPage: function () {
      let _that = this;
      if (process.env.NODE_ENV !== "production") {
        window.location.href =
          "http://192.168.71.34:8081/?client=" +
          _that.$store.state.client +
          "&version=" +
          _that.$store.state.version;
      } else {
        window.location.href =
          "http://yc.iepose.com/jdxb_server_pc_v4/?client=" +
          _that.$store.state.client +
          "&version=" +
          _that.$store.state.version;
      }
    },
    showDownloadClick: function () {
      let _that = this;
      _that.$store.state.isShowDownload = 1;
    },
    knowClick: function () {
      let _that = this;
      _that.$router.push("/home/help");
    },
    closeClick: function () {
      let _that = this;
      _that.show = false;
    },
    onInputFocus: function () {
      this.inputTips = "";
    },
    onInputBlur: function () {
      if (!this.activecode) {
        this.inputTips = "输入绑定码";
      }
    },
    bindDeviceClick: function () {
      let _that = this;
      if (!_that.activecode) {
        _that.$store.state.toast = "请输入绑定码";
        return;
      } else if (_that.activecode.length < 6) {
        _that.$store.state.toast = "绑定码无效";
        return;
      }
      _that.$emit("bindDeviceClick", _that.activecode);
    },
    inputFun: function () {
      let _that = this;
      if (_that.activecode.length > 6) {
        _that.activecode = _that.activecode.slice(0, 6);
      }
    },
  },
  mounted: function () {
    let _that = this;
    _that.sendUserlog(["no_bind_alert", ""]);
  },
};
</script>

<style lang="less" scoped>
.nobind {
  padding-top: 1px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .title {
    margin-top: 120px;
    margin-bottom: -60px;
    font-weight: 700;
    color: #143977;
    font-size: 24px;
    line-height: 32px;
    text-align: center;
  }
  .code-wrap {
    position: relative;
    margin: 0 auto;
    margin-top: 85px;
    width: 286px;
    height: 48px;
    border: 1px solid #cbcdd1;
    box-shadow: 0px 2px 6px rgba(201, 206, 210, 0.2);
    border-radius: 86px;
    overflow: hidden;
    background-color: #fcfdff;

    .tips {
      position: absolute;
      left: 0;
      top: 0;
      width: 286px;
      height: 48px;
      text-align: center;
      line-height: 48px;
      font-size: 16px;
      color: #666666;
    }
    input {
      position: absolute;
      left: 0;
      top: 0;
      text-align: center;
      width: 286px;
      height: 48px;
      background-color: transparent;
      letter-spacing: 10px;
      color: #143977;
      font-weight: 700;
      font-size: 24px;
      font-family: "DIN";
    }
  }
  .btn {
    margin: 0 auto;
    margin-top: 24px;
    width: 286px;
    height: 48px;
    background: linear-gradient(173deg, #133977 4%, #103570 132%);
    box-shadow: 0px 4px 12px rgba(172, 178, 186, 0.2);
    border-radius: 24px;
    font-weight: 700;
    font-size: 16px;
    line-height: 48px;
    text-align: center;
    color: #fcfcfc;
    cursor: pointer;
  }
  .server-btn {
    margin: 0 auto;
    margin-top: 24px;
    width: 286px;
    height: 48px;
    background-color: #c98657;
    background-image: linear-gradient(
      180deg,
      #dfa176 0%,
      #c98657 0.01%,
      #dda177 100%
    );
    box-shadow: 0px 4px 12px rgba(172, 178, 186, 0.2);
    border-radius: 24px;
    font-weight: 700;
    font-size: 16px;
    line-height: 48px;
    text-align: center;
    color: #fcfcfc;
    cursor: pointer;
    .btn-tips {
      font-size: 12px;
    }
  }
  .btn:hover,
  .server-btn:hover {
    cursor: pointer;
    opacity: 0.9;
  }
  .getcode {
    margin-top: 15px;
    text-align: center;
    font-size: 14px;
    line-height: 22px;
    color: #143977;
    cursor: pointer;
    .getcode-icon {
      display: inline-block;
      margin-right: 4px;
      vertical-align: top;
      width: 20px;
      height: 20px;
      background-image: url("../../assets/remote/getcode.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
  .know-us {
    position: absolute;
    left: 35px;
    bottom: 40px;
    padding-top: 1px;
    width: 908px;
    height: 102px;
    background-image: url("../../assets/remote/strength.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    .know-text {
      margin-top: 21px;
      margin-left: 156px;
      font-weight: 600;
      font-size: 16px;
      line-height: 21px;
      color: #4a4a4a;
    }
    .know-btn {
      padding-left: 16px;
      margin-left: 156px;
      margin-top: 9px;
      width: 96px;
      height: 28px;
      border: 1px solid #8795a5;
      border-radius: 24px;
      color: #133875;
      font-size: 12px;
      line-height: 28px;
      text-align: left;
      box-sizing: border-box;
      cursor: pointer;
      .know-icon {
        display: inline-block;
        margin-top: 4px;
        margin-left: 4px;
        vertical-align: top;
        width: 20px;
        height: 20px;
        background-image: url("../../assets/remote/right.svg");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
    .know-btn:hover {
      opacity: 0.9;
    }
    .close {
      position: absolute;
      right: 0;
      top: 0;
      width: 48px;
      height: 48px;
      background-image: url("../../assets/remote/close.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
  }
}
</style>